import RouteView from '../../router/RouteView.vue';
import GoodsList from './index.vue'; // 商品列表

import GoodsManageClass from './goodsManageClass.vue'; // 课时管理

import GoodsBuyStatistics from './goodsBuyStatistics.vue'; // 购买统计
import GoodsTimeStatistics from './goodsTimeStatistics.vue'; // 耗课统计

import EditClass from './editClass/index'; // 课时编辑
import EditClassPt from './campusYunPt/index.vue'; // 课时编辑

export default [
  {
    path: '/goods',
    name: 'Goods',
    component: RouteView,
    redirect: '/goods/list',
    meta: {
      title: '课程商品'
    },
    children: [
      {
        path: '/goods/list',
        name: 'GoodsList',
        component: GoodsList,
        meta: {
          title: '商品列表'
        }
      },
      {
        path: '/goods/buyStatistics',
        name: 'GoodsBuyStatistics',
        component: GoodsBuyStatistics,
        meta: {
          title: '购买统计'
        }
      },
      {
        path: '/goods/timeStatistics',
        name: 'GoodsTimeStatistics',
        component: GoodsTimeStatistics,
        meta: {
          title: '耗课统计'
        }
      },
    ]
  },
  {
    path: '/goods/editClass',
    name: 'EditClass',
    component: EditClass,
    meta: {
      title: '课时编辑'
    }
  },
  {
    path: '/goods/editClassPt',
    name: 'editClassPt',
    component: EditClassPt,
    meta: {
      title: '课时编辑'
    }
  },
  {
    path: '/goods/goodsManageClass',
    name: 'GoodsManageClass',
    component: GoodsManageClass,
    meta: {
      title: '商品课时管理'
    }
  }
];



// WEBPACK FOOTER //
// ./src/views/Goods/index.js